var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasketball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Graphic_Elements",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;fill:url(#path3034_1_);enable-background:new    ;}\n\t.st1{fill:url(#path2995_1_);}\n\t.st2{fill:url(#path3009_1_);}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "job678-026-v") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "path3034_1_",
    cx: 558.8599,
    cy: 25497.5645,
    r: 480.6686,
    gradientTransform: "matrix(0.99 0 0 0.13 62.51 -2120.6899)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path3034",
    className: "st0",
    d: "M1091.3,1086.1c0,33.4-212.8,60.5-475.5,60.5s-475.5-27.1-475.5-60.5 c0-33.4,212.9-60.4,475.5-60.4S1091.3,1052.7,1091.3,1086.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3866"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "path2995_1_",
    cx: 3800.2471,
    cy: 3573.8772,
    r: 371.9932,
    gradientTransform: "matrix(0.5 1.8 -1.76 0.49 5048.5298 -8121.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9955"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FF6600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A14D2B"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path2995",
    className: "st1",
    d: "M1114,567.4c0,283.9-230.1,514-514,514S86,851.3,86,567.4s230.1-514,514-514 S1114,283.6,1114,567.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path3009_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 692.5717,
    y1: 4961.4204,
    x2: 1423.0815,
    y2: 4345.8667,
    gradientTransform: "matrix(1.04 0 0 1.04 -481.75 -4275.96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0A0400",
      stopOpacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B1100"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path3009",
    className: "st2",
    d: "M484.9,66.3c-7.9,1.8-15.7,3.8-23.4,6c-12.1,7.9-23.8,16.6-34.8,26 c-37,32.3-62.5,62.3-94.1,110.5c-29.9,47.2-51.3,97.2-69.8,142c-7.2,16.5-31.5,106.9-37.7,140.3c-2.4,12.7-4.7,23.6-5.3,24.2 c-3.4,3.4-38.5-12.3-52.3-23.4c-20.8-16.8-28.9-29.1-38.5-57.6c-6.7-19.9-7.4-27.8-5.7-59.4c-5.5,13.6-10.5,27.5-14.9,41.7v0.1 c0,3.6,0.2,7,0.6,10.1c6.9,56.4,49.5,94.8,109.8,118.4c0.9,2.4,0.3,17.2-1.3,32.8s-2,44.3-1,63.7c1.5,28.7,1,34.5-2.8,31.5 c-42.2-10.7-89.2-22.1-123.4-39.4c1.5,11.6,3.4,23.1,5.7,34.4c6.6,2.8,13.3,5.3,20.2,7.3c32.7,11,72.1,20.6,100.4,29.1 c0.5,39.5,8.2,60.7,13,98.5l1.4,12l-32.5-1.9c-17.9-1.1-35-0.5-37.7,1.2c-4.3,2.7-4.2,3.2,0.3,3.3c4.3,0.1,4.1,1.1-0.9,4.9 c-1.5,1.2-2.8,2.7-3.8,4.4c2.6,4.3,5.2,8.6,7.9,12.8c3.5-0.8,4.2,0.2,2.9,3.7c-0.1,0.3-0.1,0.4-0.2,0.7c0.6,1,1.3,1.9,1.9,2.9 c2.8-0.9,5.6-1.9,8.3-3.1c6.7-2.8,23.1-5.1,36.6-5.1c24.1,0,24.7,0.3,29.2,11.1c9.3,26.5,21.5,52.9,33,77.7 c8.6,18.2,26.1,45.1,46.6,72.1c8.2,5.3,16.6,10.4,25.2,15.2c-29-32.8-54.2-69-57.4-86c-12.6-23-14.3-52.5-21.1-75 c-1.4-4.7-0.9-8,1.2-8c2.2,0,21.8,6.7,43.9,14.9c48.4,15.5,99.9,36.2,138.3,59.2c78.1,46.9,151.9,78.7,228.6,98.4 c29.3,7.6,45.4,9.4,92.3,10.3c39.8,0.8,46.7,0.5,23.1-1.1c-26.9-1.8-36-3.9-44.9-10.3c-6.2-4.4-14.6-8-18.8-8 c-64.1-17.1-116.1-34.8-177.8-65.4c-16.6-8.3-51.8-26.1-78.1-39.6c-36.2-22.5-82.2-36.4-118.4-52.8c-6.2-2.8-31.3-11.6-55.9-19.6 l-44.7-14.5l-6-29.2c-6.4-31.3-13.2-81.5-11.2-83.4c0.7-0.7,13.7,0.6,29.1,2.8s69.4,4.5,120.2,5.2c77.9-2.4,170.2,0.9,252.8-5.2 c16.3,0,121.1-9.6,192.9-17.6c102.5-11.5,207.6-38.3,257.5-65.7c6.5-3.6,12.8-7.5,18.7-11.9c0.6-7.1,1.1-14.3,1.4-21.5 c-3.3-0.3-10.2,2.4-24.2,8.6c-35.3,15.6-116.2,37-196.1,51.7c-44.7,8.3-134.3,19-220.7,26.5c-107.9,9.3-408.6,5.6-429.7-5.3 c-6.3-3.2-9.1-63-4.5-97.9l2.8-21.3l28.3-2.8c36.6-3.6,84.2-19.6,124.4-41.8C542,398.6,698.4,289.3,864.4,228.1 c38.9-13.5,49.1-15.6,84.6-17.3l20.2-1c-6.8-7-13.9-13.9-21.1-20.5c-2.8,0-5.9,0-9.4,0c-41.5,0-93.5,12.8-143.7,35.4 C690.1,270.8,593.6,332.1,504.3,397c-34.9,25.4-70.8,51.6-79.9,58c-22.4,16-66.6,38.1-85.9,43.1c-8.7,2.2-19.1,5.5-23,7.3 c-11.6,5.5-48.5,14.1-60.5,14.1H244l2.9-22.2c3.5-26.8,13.9-86.4,23-112.8C306.9,276.6,396.1,122.5,484.9,66.3L484.9,66.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketball);
export default __webpack_public_path__ + "static/media/basketball.693e14338490186d4c56a058665221ee.svg";
export { ForwardRef as ReactComponent };